define('models/state',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                id: null,
                name: '',
            };
        }
    });
});
